import styled from "@rentiohq/web-theme";

export const SortableHeader = styled.span<{ width?: number }>`
  display: flex;
  cursor: pointer;
`;
